var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.51239 10.8496C8.41795 8.27659 12.3559 6.58032 14.3263 5.76077C19.9521 3.42078 21.1211 3.0143 21.883 3.00088C22.0506 2.99792 22.4253 3.03946 22.668 3.2364C22.873 3.4027 22.9294 3.62734 22.9563 3.78501C22.9833 3.94268 23.0169 4.30185 22.9902 4.5825C22.6854 7.78577 21.3662 15.5592 20.6951 19.147C20.4111 20.6651 19.852 21.1741 19.3107 21.2239C18.1343 21.3321 17.2409 20.4464 16.1015 19.6995C14.3186 18.5308 13.3113 17.8032 11.5807 16.6627C9.58058 15.3447 10.8772 14.6203 12.017 13.4364C12.3153 13.1265 17.4986 8.4119 17.5989 7.98421C17.6115 7.93072 17.6231 7.73133 17.5046 7.62605C17.3862 7.52077 17.2114 7.55677 17.0852 7.5854C16.9064 7.62599 14.0581 9.50862 8.54035 13.2333C7.73187 13.7885 6.99958 14.0589 6.34347 14.0448C5.62016 14.0291 4.2288 13.6358 3.19447 13.2996C1.92583 12.8872 0.91753 12.6692 1.00533 11.9688C1.05106 11.604 1.55341 11.2309 2.51239 10.8496Z",
    fill: "#282B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.12872a34be39d8270c1120699f7202da.svg";
export { ForwardRef as ReactComponent };